export default "__VITE_ASSET__c7d5465a__"